<!-- @format -->

<template>
    <!-- 登录 -->
    <el-dialog
        v-model="localVisible"
        :close-on-click-modal="false"
        title=""
        width="33%"
        @close="handleClose"
        @open="handleOpen"
    >
        <p class="dialog_title">登录</p>
        <el-form
            ref="ref_form"
            v-if="!form.tokenKey"
            label-position="left"
            label-width="60px"
            :model="form"
            style="width: 100%"
        >
            <el-form-item label="学校" prop="SchoolGuid">
                <el-select
                    v-model="form.SchoolGuid"
                    filterable
                    clearable
                    placeholder="选择学校"
                    style="width: 100%"
                >
                    <template #prefix>
                        <el-icon>
                            <OfficeBuilding />
                        </el-icon>
                    </template>
                    <el-option
                        v-for="(item, index) in options"
                        :key="index"
                        :label="item.School"
                        :value="item.Guid"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="UserAccount">
                <el-input
                    v-model="form.UserAccount"
                    clearable
                    placeholder="请填写手机号"
                >
                    <template #prefix>
                        <el-icon>
                            <User />
                        </el-icon>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="密码" prop="PassWord">
                <el-input
                    v-model="form.PassWord"
                    type="password"
                    clearable
                    show-password
                    placeholder="请填写密码"
                >
                    <template #prefix>
                        <el-icon>
                            <Lock />
                        </el-icon>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item prop="remember">
                <el-row style="width: 100%">
                    <el-col :span="12">
                        <el-checkbox v-model="form.remember" label="记住密码" />
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                        <el-button
                            type="primary"
                            link
                            @click="Pass_dialog = true"
                            >忘记密码</el-button
                        >
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item>
                <el-button-group style="width: 100%">
                    <el-button
                        type="primary"
                        @click="dataSub"
                        class="_fr"
                        style="width: 30%"
                        >登录</el-button
                    >
                </el-button-group>
            </el-form-item>
        </el-form>
    </el-dialog>

    <!-- 忘记密码 -->
    <el-dialog v-model="Pass_dialog" width="33%">
        <p class="dialog_title">忘记密码</p>
        <el-form
            ref="Pass_form"
            :model="Pass_form"
            :rules="Pass_rules"
            label-width="120px"
        >
            <el-form-item label="学校" prop="SchoolGuid">
                <el-select
                    v-model="Pass_form.SchoolGuid"
                    filterable
                    clearable
                    placeholder="选择学校"
                    style="width: 100%"
                >
                    <template #prefix>
                        <el-icon>
                            <OfficeBuilding />
                        </el-icon>
                    </template>
                    <el-option
                        v-for="(item, index) in options"
                        :key="index"
                        :label="item.School"
                        :value="item.Guid"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="账号" prop="UserAccount">
                <el-input
                    v-model="Pass_form.UserAccount"
                    placeholder="账号由字母或数字组成，至少6位!"
                />
            </el-form-item>
            <el-form-item label="手机号" prop="Tel">
                <el-input v-model="Pass_form.Tel" placeholder="填写 手机号" />
            </el-form-item>
            <el-form-item label="验证码" prop="Code">
                <el-input v-model="Pass_form.Code" placeholder="填写 验证码">
                    <template #append>
                        <CodeButton :tel="Pass_form.Tel" />
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="密码" prop="NewPassWord">
                <el-input
                    v-model="Pass_form.NewPassWord"
                    type="password"
                    show-password
                    placeholder="填写 密码"
                />
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input
                    v-model="Pass_form.checkPass"
                    type="password"
                    show-password
                    placeholder="填写 确认密码"
                />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary" @click="PassSub"> 提交 </el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script>
import { storeInit } from "@/store/index.js";
import CodeButton from "@/components/code_button";
export default {
    name: "Login",
    components: {
        CodeButton,
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        }, // 控制弹窗显示/隐藏的 props
    },
    data() {
        return {
            // 登录
            localVisible: false,
            options: [],
            form: JSON.parse(localStorage.remember_user_vcase || "{}"),
            // 忘记密码
            Pass_dialog: false,
            Pass_form: {},
            Pass_rules: {
                SchoolGuid: [
                    //
                    {
                        required: true,
                        message: "请选择学校",
                        trigger: "blur",
                    },
                ],
                UserAccount: [
                    //
                    {
                        required: true,
                        message: "请输入账号",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!/^[a-zA-Z0-9_]+$/.test(value)) {
                                callback(new Error("账号由字母或数字组成"));
                            }
                            if (value.length < 6) {
                                callback(new Error("账号至少6位!"));
                            }
                            if (value.length > 16) {
                                callback(new Error("账号至多16位!"));
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ],
                Tel: [
                    //
                    {
                        required: true,
                        message: "请输入电话号码",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!/^1[3456789]\d{9}$/.test(value)) {
                                callback(new Error("请输入正确的电话号码"));
                                return;
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ],
                Code: [
                    //
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                ],
                NewPassWord: [
                    //
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length < 6) {
                                    callback(
                                        new Error(
                                            "密码长度至少为6个字符至多为12个字符！"
                                        )
                                    );
                                    return;
                                }
                                if (value.length > 12) {
                                    callback(
                                        new Error(
                                            "密码长度至少为6个字符至多为12个字符！"
                                        )
                                    );
                                    return;
                                }
                                if (this.form.checkPass) {
                                    this.$refs.form.validateField(
                                        "checkPass",
                                        () => null
                                    );
                                }
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ],
                checkPass: [
                    //
                    {
                        required: true,
                        message: "请确认密码",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value !== this.Pass_form.NewPassWord) {
                                callback(
                                    new Error("两次密码输入不一致，请重新输入")
                                );
                                return;
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    watch: {
        // 监听父组件传递的 isVisible 变化，同步到本地数据
        isVisible(newVal) {
            this.localVisible = newVal;
        },
        // 监听本地 visible 变化，通知父组件更新状态
        localVisible(newVal) {
            if (!newVal) {
                // 当弹窗关闭时（本地 visible 变为 false）
                this.$emit("update:isVisible", newVal); // 触发事件通知父组件
            }
        },
    },
    methods: {
        handleOpen() {
            // 当弹窗从隐藏变为显示时（visible 为 true）调用接口
            this._ajax.post({
                url: "GetSchoolList",
                data: {},
                success: (res) => {
                    this.options = res.data;
                },
            });
        },
        dataSub() {
            if (this.form.remember) {
                localStorage.remember_user_vcase = JSON.stringify(this.form);
            } else {
                localStorage.remember_user_vcase = "";
            }
            this._ajax.post({
                url: "Login",
                data: this.form,
                success: (res) => {
                    this.$message({
                        type: "success",
                        message: res.message,
                        duration: 10,
                    });
                    localStorage.Authorization_vcase = res.data.Guid;
                    this._ajax.store.user = res.Header;
                    localStorage.VCASE_user = JSON.stringify(res.Header);

                    const authStore = storeInit();
                    authStore.loginSuccess();

                    const targetPath = authStore.targetPath;
                    // console.log('targetPath',targetPath)
                    if (targetPath != "/") {
                        // 0:审核中
                        // 9:审核未通过
                        // 1:审核通过但无权限
                        // 8:学校权限到期
                        // 2:正常 有权限
                        if (res.Header.UserType == 9 && !targetPath.includes('share_case')) {
                            this.$message.warning("您的审核尚未通过，请等待!");
                            return;
                        } else if (res.Header.UserType == 2 || targetPath.includes('share_case')) {
                            // 跳转到目标页
                            this.$router.push(targetPath);

                            // 重置目标页（避免下次登录时重复跳转）
                            authStore.resetTargetPath();
                            authStore.closeLoginModal();
                        } else {
                            this.$message.warning("暂无访问权限!");
                            return;
                        }
                    }

                    this.$message.success("登录成功");
                    // 0:审核中
                    // 9:审核未通过
                    // 1:审核通过但无权限
                    // 8:学校权限到期
                    // 2:正常 有权限
                    // if(res.Header.UserType == 9){
                    //     this.$message.warning('您的审核未通过!');
                    //     return
                    // } else if(res.Header.UserType == 2){
                    //     this.$message({
                    //         type: "success",
                    //         message: res.message,
                    //         duration: 10,
                    //     });
                    //     localStorage.Authorization_vcase = res.data.Guid;
                    //     this._ajax.store.user = res.Header;
                    //     localStorage.VCASE_user = JSON.stringify(res.Header);

                    //     const authStore = storeInit();
                    //     authStore.loginSuccess();

                    //     const targetPath = authStore.targetPath;
                    //     if(targetPath != '/'){
                    //         // 跳转到目标页
                    //         this.$router.push(targetPath);

                    //         // 重置目标页（避免下次登录时重复跳转）
                    //         authStore.resetTargetPath();
                    //         authStore.closeLoginModal();
                    //     }

                    //     this.$message.success('登录成功');
                    // }else{
                    //     this.$message.warning('暂无访问权限!');
                    //     return
                    // }

                    // this.isVisible = false
                },
            });
        },
        // 关闭弹窗逻辑
        handleClose() {
            this.localVisible = false; // 关闭弹窗
            const authStore = storeInit();
            authStore.closeLoginModal(); // 调用 Pinia 的关闭方法
            // this.$refs.ref_form.resetFields(); // 重置表单（清空输入和校验提示）
        },
        PassSub() {
            this.$refs.Pass_form.validate((valid, fields) => {
                if (valid) {
                    this._ajax.post({
                        url: "RetrieveUserPwd",
                        data: this.Pass_form,
                        success: (res) => {
                            this.$message({
                                type: "success",
                                message: res.message,
                            });
                            this.Pass_dialog = false;
                        },
                    });
                } else {
                    for (var i in fields) {
                        for (var j = fields[i].length - 1; j >= 0; j--) {
                            this.$message({
                                type: "error",
                                message: fields[i][j].message,
                            });
                        }
                    }
                }
            });
        },
    },
};
</script>
<style scoped></style>
